import React from 'react';
import { string } from 'yup';
import { password } from '@becollective/utils';

export const passwordSchema = string()
  .required('Password is required')
  .test(
    'is-valid-password',
    <div>
      Please ensure your password contains:
      <br />
      - at least 12 characters
      <br />
      - a lower case letter
      <br />
      - an upper case letter
      <br />- a number
    </div>,
    password.isValid,
  );
